/*
  Toggle bulma tabs and their content - supports multiple tabs on one page.
  Usage: Call `attachTabs()` in your .js when the document loading is ready.
  Note: attachTabs() has an default parameter (idxActivate = 0) that activates
        the first tab - yu may give another tab index here or -1 to handle
        the initial tab activateion in your template yourself.

  Example HTML Code:
  <div class="tabs-container">
    <div class="tabs">
      <ul>
        <li data-target="tab-pictures"><a>Pictures</a></li>
        <li data-target="tab-music"><a>Music</a></li>
        <li data-target="tab-videos"><a>Videos</a></li>
      </ul>
    </div>

    <div class="tabs-content">
      <div class="tab" id="tab-pictures">
        Tab "Pictures" content goes here...
      </div>

      <div class="tab" id="tab-music">
        Tab "Music" content goes here...
      </div>

      <div class="tab" id="tab-videos">
        Tab "Videos" content goes here...
      </div>
    </div>
  </div>
*/

import {
  $$
} from "../utils/selector";

function attachTabs(idxActivate = 0) {
  let $container = $$(document, ".tabs-container");

  if ($container.length > 0) {
    $container.forEach(function (container) {
      var $navs = $$(container, ".tabs ul li");
      var $tabs = $$(container, ".tabs-content .tab");

      if ($navs.length > 0) {
        // Activate given tab, if any
        if (idxActivate >= 0 && idxActivate < $navs.length) {
          toggleTab($navs, $tabs, $navs[idxActivate])
        }

        // Toggle tab on click event
        $navs.forEach(function (nav) {
          nav.addEventListener('click', function () {
            toggleTab($navs, $tabs, nav);
          });
        });
      }
    });
  }
}

function toggleTab(navs, tabs, selNav) {
  let $targetId = selNav.dataset.target;

  // Activate given tab
  navs.forEach(function (nav) {
    if ($targetId == nav.dataset.target) {
      nav.classList.add("is-active");
    } else {
      if (nav.classList.contains("is-active")) {
        nav.classList.remove("is-active");
      }
    }
  });

  // activate content for given tab
  tabs.forEach(function (tab) {
    if ($targetId == tab.id) {
      if (tab.classList.contains("is-hidden")) {
        tab.classList.remove("is-hidden");
      }
    } else {
      tab.classList.add("is-hidden");
    }
  });
}

export {
  attachTabs
};
